export default __webpack_public_path__ + "static/media/p8.3b25559d.jpg";